<template>
  <div class="login-wrap" :class="{fixed: fixed}">
    <img class="close" v-if="showClose" @click="close" src="https://img.thebeastshop.com/app/4.0/icon/icon-back.png">
    <div class="tit" :class="{
      'show-close': showClose
    }">快捷注册登录</div>
    <div class="login-form">
      <div class="item">
        <div class="area" @click="selectCountry">{{ country.country_code }}</div>
        <i class="split"></i>
        <div class="tel">
          <input type="number" class placeholder="请输入手机号" 
            v-model="phone"
            @blur="blur"
            @focus="focus">
        </div>
      </div>
      <div class="item">
        <input class placeholder="图片验证码" v-model="captcha"
          @blur="blur"
          @focus="focus">
        <div class="img-code" @click="getCaptcha">
          <img :src="imgCode"/>
        </div>
      </div>
      <div class="item">
        <i class="input-del" @click="delSmsCode" v-show="smsCode"></i>
        <input class placeholder="请输入短信验证码" v-model="smsCode"
          @blur="blur"
          @focus="focus">
        <div class="tel-code"
          :class="{
            enabled: !smsSended && (phone && phone.length == 11 && captcha)
          }"
          @click="getSms">
          {{ smsSended ? timeDownText : '获取验证码' }}
        </div>
      </div>
      <p class="err-msg">{{errmsg}}</p>
      <div class="btn" 
        :class="{
          enabled: enableLogin
        }" 
        @click="login">登录</div>
    </div>

    <div class="login-other">
      <div class @click="showPassLogin">密码登录</div>
    </div>
    <div class="footer" :class="{fixed:fixed}" v-if="!showPass">
      <!-- <div class="mask"></div> -->
      <div class="rules">
        <div class="checkbox" :class="{ checked: checkRule }" @click="checkRule = !checkRule"></div>我已阅读并同意<a href="https://m.thebeastshop.com/eula">《野兽派服务条款》</a>和<a href="https://m.thebeastshop.com/rule">《隐私政策》</a>
      </div>
    </div>

    <div class="bg"><img src="https://img.thebeastshop.com/app/4.0/icon/login/login-bg.png" /></div>

    <pass-login v-if="showPass" @cancel="showPassLogin" @login="passLogin"/>
  </div>
</template>

<script>
import Vue from 'vue'
import Select from '@/plugins/select'
import PassLogin from './pass-login.vue'
import _country from './data/country.js'
import api from './api.js'
function isIphoneX() {
  return /iphone/gi.test(navigator.userAgent) && screen.height >= 812
}

Vue.use(Select)

let timeDown = null

export default {
  components: {
    PassLogin
  },

  props: {
    showClose: {
      default: true
    }
  },

  data () {
    return {
      phone: '',
      captcha: '',
      showPass: false,
      smsCode: '',
      countryIndex: 0,
      imgCode: null,
      verifyType: 'SMS_LOGIN',
      smsSended: false,
      timeDownText: '60秒后获取',
      errmsg: '',
      fixed: false,
      checkRule: false,
      isIphoneX: isIphoneX()
    }
  },

  computed: {
    country (){
      return _country[this.countryIndex]
    },

    realPhone () {
      return `${this.country.country_code}-${this.phone}`
    },

    enableLogin () {
      return this.phone && this.smsCode
    }
  },

  created () {
    this.init()
  },

  methods: {
    init () {
      this.getCaptcha()
    },

    login () {
      const {
        phone,
        realPhone,
        smsCode,
        verifyType,
        checkRule
      } = this

      if (!this.enableLogin) return
      this.errmsg = ''

      if(!checkRule){
        this.errmsg = '请先勾选同意《野兽派服务条款》和《隐私政策》'
        return
      }

      if (phone.length != 11){
        this.errmsg = '请输入正确的手机号'
        return
      }

      if (this.smsCode == ''){
        this.errmsg = '请输短信验证码'
        return
      }

      const authData = {
        principal: realPhone,
        credential: smsCode,
        authType: verifyType
      }

      api.login(authData)
      .then(({ data }) => {
        if (data.member.enroll) {
          try{
            TDH5SDK.account.register(data.member.id)
          }catch(e){
          
          }
          
        }
        if(data.toast) {
          this.$toast(data.toast)
            .then(() => {
              this.$emit('login', data.member)
            })
        } else {
          this.$emit('login', data.member)
        }
        
      })
      .catch(err => {
        this.errmsg = err.message
      })
    },

    passLogin (data) {
      // console.log('1111111')
      // console.log(data)
      this.$emit('login', data)
    },

    getSms () {
      const {
        phone,
        realPhone,
        captcha,
        verifyType,
        country,
        smsSended
      } = this

      this.errmsg = ''

      if (smsSended) return

      if (phone.length != 11){
        this.errmsg = '请输入正确的手机号'
        return
      }

      if (this.captcha == ''){
        this.errmsg = '请输入图形验证码'
        return
      }
      sa.track('GetCode', {
        service_type: '快捷登录注册'
      })
      api.sms(realPhone, captcha, verifyType)
      .then(({ data }) => {
        this.smsSended = true
        this.startTimeDown()
        // this.getCaptcha()
      })
      .catch(err => {
        this.errmsg = err.message
      })
    },

    startTimeDown () {
      if (timeDown) {
        clearInterval(timeDown)
      }

      let num = 60

      timeDown = setInterval(() => {
        if (num === 0) {
          this.smsSended = false
          clearInterval(timeDown)
          return
        }

        num--
        this.timeDownText = `${num}秒后获取`
      }, 1000)
    },

    getCaptcha () {
      const _timestamp = (new Date()).getTime()
      
      this.imgCode = `${process.env.AXIOS_BASE_URL}/app/captcha?_timestamp=${_timestamp}`
    },

    close: function (){
      this.$emit('cancel')  
    },

    delSmsCode () {
      this.smsCode = ''
    },  

    selectCountry () {
      // track({
      //   name: 'areaCode'
      // })

      this.$select(_country.map((item) => {
        return item.country_name_cn
      }))
      .then((data) => {
        this.countryIndex = data
      })
      .catch(()=>{
        // console.log('select-cancel');
      })
    },

    showPassLogin () {
      this.showPass = !this.showPass
    },

    blur () {
      this.fixed = false
    },

    focus () {
      this.fixed = true
    }
  }
}
</script>

<style lang="stylus">
@import 'index.styl'
</style>



// WEBPACK FOOTER //
// index.vue?5e838ad0